import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage'; 
import NosValeursPage from './pages/valeurs-page/NosValeursPage';
import NosMetiers from './pages/metiers-page/NosMetiers'; 
import NosRealisations from './pages/NosRealisations';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Composant pour faire défiler la page jusqu'à l'ancre
const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToAnchor /> {/* Gérer le scroll au chargement */}
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/nos-valeurs" element={<NosValeursPage />} />
          <Route path="/nos-metiers" element={<NosMetiers />} />
          <Route path="/nos-realisations" element={<NosRealisations />} />
          <Route path="/#contact" element={<HomePage />} /> {/* Permet de scroller vers #contact */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
